import { createStore } from "vuex";

export default createStore({
  state: {
    licenseCode: "520111207480",
  },
  mutations: {
    setLicenseCode(state, licenseCode: string) {
      state.licenseCode = licenseCode;
    },
  },
  actions: {},
  modules: {},
});
